var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingularLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes bounce{0%,to{transform:translateY(0)}50%{transform:translateY(-6px)}}")), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 3,
    fill: "currentColor",
    style: {
      animation: "bounce .6s cubic-bezier(.33,.66,.66,1) infinite"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "currentColor",
    style: {
      animation: "bounce .6s cubic-bezier(.33,.66,.66,1) infinite .1s"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 3,
    fill: "currentColor",
    style: {
      animation: "bounce .6s cubic-bezier(.33,.66,.66,1) infinite .2s"
    }
  }));
}
export default SvgSingularLoader;